import { useState, useEffect } from 'react';
import { benchmarkService } from '../services/benchmarkService';
import type { BenchmarkProgress } from '../types/benchmark';

export function useBenchmarkProgress(runId: string | null) {
  const [progress, setProgress] = useState<BenchmarkProgress | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!runId) {
      setProgress(null);
      return;
    }

    const fetchProgress = async () => {
      try {
        const data = await benchmarkService.getProgress(runId);
        setProgress(data);
        setError(null);

        // Stop polling if completed or failed
        if (data.status === 'completed' || data.status === 'failed') {
          clearInterval(interval);
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch progress');
      }
    };

    // Initial fetch
    fetchProgress();

    // Poll every 2 seconds
    const interval = setInterval(fetchProgress, 2000);

    return () => clearInterval(interval);
  }, [runId]);

  return { progress, error };
}
